import React, { useContext, useEffect, useState } from "react";
import { AuthContextTwo } from "../../../../contexts/AuthProviderTwo";
import ModalPersonalMobile from "../../../TutorProfile/GreenTutorProfile.js/EditAndViewProfile/EditedProfilesPage/modalForm/ModalPersonalMobile";
import ModalEducational from "../../../TutorProfile/GreenTutorProfile.js/EditAndViewProfile/EditedProfilesPage/modalForm/ModalEducational";
import ModalPreffer from "../../../TutorProfile/GreenTutorProfile.js/EditAndViewProfile/EditedProfilesPage/modalForm/ModalPreffer";

const EditTutorProfileMobile = () => {
    const [active, setActive] = useState("viewProfile");
    const [isModalVisible, setIsModalVisible] = useState(false);
  
    const toggleProfileView = () => {
      setActive((prevActive) =>
        prevActive === "viewProfile" ? "editProfile" : "viewProfile"
      );
    };
  
    const openModal = () => {
      setIsModalVisible(true);
    };
  
    const closeModal = () => {
      setIsModalVisible(false);
    };
  
    const { userTwo, logOutTwo } = useContext(AuthContextTwo);
  
    const [imageUrl, setImageUrl] = useState(
      "https://img.freepik.com/free-photo/portrait-expressive-young-man-wearing-formal-suit_273609-6943.jpg"
    );
    const [imageFile, setImageFile] = useState(null);
    const [loading, setLoading] = useState(false); // Add loading state
    const [Mainloading, setMainLoading] = useState(true);
    const handleImageUpload = (event) => {
      const file = event.target.files[0];
      setImageFile(file);
    };
  
    const updateImage = async () => {
      if (!imageFile) {
        console.error("Please select an image.");
        return;
      }
  
      setLoading(true);
  
      const formData = new FormData();
      formData.append("image", imageFile);
  
      const imgbbApiKey = "4caaf6556f5639c7ac2506637cfd88d2";
      const imgbbUploadUrl = `https://api.imgbb.com/1/upload?key=${imgbbApiKey}`;
  
      try {
        const response = await fetch(imgbbUploadUrl, {
          method: "POST",
          body: formData,
        });
  
        const data = await response.json();
        if (data.data && data.data.url) {
          setImageUrl(data.data.url);
  
          // Update the image URL in the DOM
          const imageElement = document.getElementById("profileImage");
          if (imageElement) {
            imageElement.src = data.data.url;
          }
  
          // Update the image URL on the server
          const updateUrl = "https://tutor-tree-server-1.vercel.app/user/img";
          const updateResponse = await fetch(updateUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: userTwo.email,
              img: data.data.url,
            }),
          });
  
          const updateData = await updateResponse.json();
          console.log("Image URL updated on the server:", updateData);
        } else {
          console.error("Failed to upload image to imgBB.");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        setLoading(false); // Set loading to false after upload
        // Close the modal after upload
        handleButtonClick();
      }
    };
    const [profileData, setProfileData] = useState([]);
    const [validPercentage, setValidPercentage] = useState(0);
  
    const fetchData = async () => {
      const UserEmail = userTwo?.email; // Ensure this variable has the correct email value.
      const url = `https://tutor-tree-server-1.vercel.app/user/${UserEmail}`;
      console.log("url", url);
      const res = await fetch(url);
      const data = await res.json();
      setProfileData(data);
      setMainLoading(false);
      calculateValidPercentage(data);
    };
  
    useEffect(() => {
      fetchData();
  
      const intervalId = setInterval(() => {
        fetchData();
      }, 1000);
  
      return () => clearInterval(intervalId);
    }, []);
  
    const calculateValidPercentage = (data) => {
      // Assuming data is an array of profile objects
      if (!Array.isArray(data) || data.length === 0) {
        setValidPercentage(0);
        return;
      }
  
      // Fields to consider for percentage calculation
      const fields = [
        "name",
        "email",
        "phone",
        "area",
        "city",
        "emergencyNmbr",
        "gender",
        "religion",
        "HSCgroup",
        "HSCinstitute",
        "HSCresult",
        "HonsInstitute",
        "HonsMajor",
        "HonsSemester",
        "MastersInstitute",
        "MastersMejor",
        "MastersSemester",
        "SSCgroup",
        "SSCinstitute",
        "experience",
        "preArea1",
        "preArea2",
        "preCategories1",
        "preCategories2",
        "preCategories3",
        "preCategories4",
        "preClasses1",
        "preClasses2",
        "preClasses3",
        "preLocation1",
        "preSubject1",
        "preSubject2",
      ];
  
      let totalValidFields = 0;
      let totalFields = fields.length * data.length;
  
      data.forEach((profile) => {
        totalValidFields += fields.filter(
          (field) => profile[field] && profile[field].toString().trim() !== ""
        ).length;
      });
  
      // Calculate the overall percentage of valid fields across all profiles
      const percentage = (totalValidFields / totalFields) * 100;
      setValidPercentage(percentage);
    };
  
    useEffect(() => {
      fetchData();
    }, []);
  
    const [isOpen, setIsOpen] = useState(false);
  
    const handleButtonClick = () => {
      setIsOpen(!isOpen);
    };

 const [isModalVisiblePersonal, setIsModalVisiblePersonal] = useState(false);

 const openModalPersonal = () => {
    setIsModalVisiblePersonal(true);
  };

  const closeModalPersonal = () => {
    setIsModalVisiblePersonal(false);
  };

 const [isModalVisibleEducation, setIsModalVisibleEducation] = useState(false);

 const openModalEducation = () => {
    setIsModalVisibleEducation(true);
  };

  const closeModalEducation = () => {
    setIsModalVisibleEducation(false);
  };
 
  const [isModalVisiblePrefer, setIsModalVisiblePrefer] = useState(false);

 const openModalPrefer = () => {
    setIsModalVisiblePrefer(true);
  };

  const closeModalPrefer = () => {
    setIsModalVisiblePrefer(false);
  };


  return (
    <div className="mt-5 h-screen">
       <div className="bg-white rounded-xl p-2">
        <h1 className="text-md text-green-900 font-signika my-2">Upload Profile Image</h1>
          <div className="mx-auto w-full ">
            <label className="flex w-full cursor-pointer appearance-none items-center justify-center rounded-md border-2 border-dashed border-gray-200 p-6 transition-all hover:border-primary-300">
              <div className="space-y-1 text-center">
                <div className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="h-6 w-6 text-gray-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                    />
                  </svg>
                </div>
                <p className="text-sm text-gray-500">
                  SVG, PNG, JPG or GIF (max. 800x400px)
                </p>
              </div>
              <input
                id="imageUpload"
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className="sr-only"
              />
            </label>
          </div>
          {loading ? (
            <button
              className="my-5  flex justify-center items-center text-white w-32 h-10 rounded-lg bg-green-700 font-roboto hover:bg-green-900"
              disabled
            >
              Uploading...
            </button>
          ) : (
            <button
              className="my-5  flex justify-center items-center text-white w-32 h-10 rounded-lg bg-green-700 font-roboto hover:bg-green-900"
              onClick={updateImage}
            >
              Upload Image
            </button>
          )}
       </div>
       <h1 className="text-md font-signika text-green-900 my-3">Update your profile Information</h1>
       <div className="grid grid-cols-2 gap-2 mt-2">
          <button onClick={openModalPersonal} className=" bg-white shadow-md p-4 rounded-xl flex flex-col justify-between gap-3 items-center text-2xl font-signika text-green-900">
          <img alt="" className="w-16" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNjYgNjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxwYXRoIGQ9Ik00Ny43IDQxLjNjLTMuOC0xLTYuOC0xLjgtNy44LTUuN2wzLjctNi42YzIuMi0xLjYgMy41LTMuOCAzLjQtNS45IDAtMS43LS45LTMuMy0yLjQtNC41IDEuNy0zLjQgMi4yLTYuMSAxLjItOC4yLS43LTEuNi0yLjItMi44LTQuNS0zLjVDNDAgNC4xIDM3LjEgMi4zIDMzLjQgMmMtNS4xLS41LTEwLjMgMS44LTEyLjYgNS42LTEuNCAyLjItMi40IDUuOS41IDExLTEuNSAxLjItMi40IDIuOC0yLjQgNC41IDAgMi4xIDEuMiA0LjMgMy40IDUuOWwzLjcgNi42Yy0xIDMuOC0zLjggNC42LTcuNSA1LjdDMTIuOCA0MyA1LjYgNDUuMiA0LjkgNjAuMmMtLjEgMSAuMyAxLjkgMSAyLjYuNy44IDEuNiAxLjIgMi41IDEuMmg0OS4xYzEgMCAxLjktLjQgMi41LTEuMS43LS43IDEtMS42IDEtMi41LjEtMTUuNy03LjMtMTcuNi0xMy4zLTE5LjF6TTMxLjYgNDhsMS4yLS41IDEuMi41LTEuMiAxLjZ6bS0zLjgtLjUtLjgtNS45IDQuMSA0LjR6TTI5LjQgNjJsMy41LTguMiAzLjYgOC4yem04LjQtMTQuNC0zLjMtMS41IDQuMi00LjJ6bS01LTIuNy02LTYuM2MuMi0uNC41LS45LjYtMS4zIDEuOCAxLjQgMy42IDIuMSA1LjUgMi4xIDEuOCAwIDMuNi0uNyA1LjMtMi4xLjIuNS41IDEgLjcgMS40eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCI+PC9wYXRoPjwvZz48L3N2Zz4=" />
               Personal
          </button>
          <button onClick={openModalEducation} className=" bg-white shadow-md p-4 rounded-xl flex flex-col justify-between gap-3 items-center text-2xl font-signika text-green-900">
          <img alt="" className="w-16" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMjk2Ljk5OSAyOTYuOTk5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIj48Zz48cGF0aCBkPSJNNDUuNDMyIDM1LjA0OWgtLjAyNWExMC40NzQgMTAuNDc0IDAgMCAwLTcuNDQ2IDMuMDg1IDEwLjU4MyAxMC41ODMgMCAwIDAtMy4xMjggNy41NDN2MTU5LjM2NWMwIDUuODQ0IDQuNzczIDEwLjYxIDEwLjY0MSAxMC42MjUgMjQuNzM4LjA1OSA2Ni4xODQgNS4yMTUgOTQuNzc2IDM1LjEzNlY4NC4wMjNjMC0xLjk4MS0uNTA2LTMuODQyLTEuNDYxLTUuMzgyLTIzLjQ2Ny0zNy43OTItNjguNTYzLTQzLjUzNC05My4zNTctNDMuNTkyek0yNjIuMTY3IDIwNS4wNDJWNDUuNjc2YzAtMi44NTItMS4xMTEtNS41MzEtMy4xMjgtNy41NDNhMTAuNDc3IDEwLjQ3NyAwIDAgMC03LjQ0NS0zLjA4NWgtLjAyNmMtMjQuNzkzLjA1OS02OS44ODkgNS44MDEtOTMuMzU3IDQzLjU5My0uOTU1IDEuNTQtMS40NiAzLjQwMS0xLjQ2IDUuMzgydjE2Ni43NzljMjguNTkyLTI5LjkyMSA3MC4wMzgtMzUuMDc3IDk0Ljc3Ni0zNS4xMzYgNS44NjctLjAxNSAxMC42NC00Ljc4MSAxMC42NC0xMC42MjR6IiBmaWxsPSIjMDA4MDAwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PHBhdGggZD0iTTI4Ni4zNzMgNzEuODAxaC03LjcwNnYxMzMuMjQxYzAgMTQuOTIxLTEyLjE1NyAyNy4wODgtMjcuMTAxIDI3LjEyNS0yMC45ODMuMDUtNTUuNTgxIDQuMTUzLTgwLjA4NCAyNy4zNDQgNDIuMzc4LTEwLjM3NiA4Ny4wNTItMy42MzEgMTEyLjUxMiAyLjE3MWExMC42MDYgMTAuNjA2IDAgMCAwIDkuMDExLTIuMDU0IDEwLjU2NyAxMC41NjcgMCAwIDAgMy45OTQtOC4zMDF2LTE2OC45Yy4wMDEtNS44NTktNC43NjctMTAuNjI2LTEwLjYyNi0xMC42MjZ6TTE4LjMzMiAyMDUuMDQyVjcxLjgwMWgtNy43MDZDNC43NjggNzEuODAxIDAgNzYuNTY4IDAgODIuNDI3djE2OC44OTdjMCAzLjI1IDEuNDU2IDYuMjc2IDMuOTk0IDguMzAxYTEwLjU5OCAxMC41OTggMCAwIDAgOS4wMTEgMi4wNTRjMjUuNDYtNS44MDMgNzAuMTM1LTEyLjU0NyAxMTIuNTExLTIuMTcxLTI0LjUwMi0yMy4xOS01OS4xLTI3LjI5Mi04MC4wODMtMjcuMzQyLTE0Ljk0My0uMDM2LTI3LjEwMS0xMi4yMDMtMjcuMTAxLTI3LjEyNHoiIGZpbGw9IiMwMDgwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiPjwvcGF0aD48L2c+PC9zdmc+" />
               Education
          </button>
          <button onClick={openModalPrefer} className=" bg-white shadow-md p-4 rounded-xl flex flex-col justify-between gap-3 items-center text-2xl font-signika text-green-900">
          <img alt="" className="w-16" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNjQgNjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxwYXRoIGQ9Ik01MCAzLjRIMTRBMTAuNjIgMTAuNjIgMCAwIDAgMy40IDE0djM2QTEwLjYyIDEwLjYyIDAgMCAwIDE0IDYwLjZoMzZBMTAuNjIgMTAuNjIgMCAwIDAgNjAuNiA1MFYxNEExMC42MiAxMC42MiAwIDAgMCA1MCAzLjR6TTEzLjQxIDE2LjIxaDIwLjc2YS41OC41OCAwIDAgMSAuNDYuMjIuNTUuNTUgMCAwIDEgLjEzLjQ5IDE0LjU1IDE0LjU1IDAgMCAwIDAgMi42NC41Ny41NyAwIDAgMS0uMTMuNS42MS42MSAwIDAgMS0uNDYuMjFIMTMuNDFhMiAyIDAgMSAxIDAtNC4wNnptMCAxMy44NWgyLjgzYTUuOTEgNS45MSAwIDEgMSAwIDQuMDZoLTIuODNhMiAyIDAgMCAxIDAtNC4wNnptMjEuMzUgMTcuNjVhLjU3LjU3IDAgMCAxLS4xMy41LjYxLjYxIDAgMCAxLS40Ni4yMUgxMy40MWEyIDIgMCAxIDEgMC00LjA2aDIwLjc2YS41OC41OCAwIDAgMSAuNDYuMjIuNTYuNTYgMCAwIDEgLjEzLjQ5IDE0LjU1IDE0LjU1IDAgMCAwIDAgMi42NHptMTUuODMuNzFoLTIuODNhNS45MSA1LjkxIDAgMSAxIDAtNC4wNmgyLjgzYTIgMiAwIDAgMSAwIDQuMDZ6bTAtMTQuM0gyOS44M2EuNTguNTggMCAwIDEtLjQ2LS4yMi41NC41NCAwIDAgMS0uMTMtLjQ5IDE0LjU1IDE0LjU1IDAgMCAwIDAtMi42NC41NC41NCAwIDAgMSAuMTMtLjQ5LjU4LjU4IDAgMCAxIC40Ni0uMjJoMjAuNzZhMiAyIDAgMCAxIDAgNC4wNnptMC0xMy44NWgtMi44M2E1LjkxIDUuOTEgMCAxIDEgMC00LjA2aDIuODNhMiAyIDAgMCAxIDAgNC4wNnoiIGRhdGEtbmFtZT0iTGF5ZXIgMjAiIGZpbGw9IiMwMDgwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiPjwvcGF0aD48L2c+PC9zdmc+" />
               Preference
          </button>
       </div>
       <ModalPersonalMobile profileData={profileData} isVisible={isModalVisiblePersonal} onClose={closeModalPersonal}></ModalPersonalMobile>
       <ModalEducational profileData={profileData} isVisible={isModalVisibleEducation} onClose={closeModalEducation}/>
       <ModalPreffer profileData={profileData} isVisible={isModalVisiblePrefer} onClose={closeModalPrefer}/>
    </div>
  );
};

export default EditTutorProfileMobile;
